var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenRightSideArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56788",
    "data-name": "Group 56788",
    transform: "translate(-715 -1410)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6898",
    "data-name": "Rectangle 6898",
    width: 16,
    height: 16,
    rx: 5,
    transform: "translate(715 1410)",
    fill: "#3ea598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M8.368,4.738l2.687,2.676a.54.54,0,0,1,.055.063l-.051-.058a.526.526,0,0,1,.067.081c.009.013.017.027.025.041s.012.022.017.034l.014.034c0,.011.008.022.012.034a.545.545,0,0,1,.022.127c0,.01,0,.019,0,.029l0,.028,0,.045a.533.533,0,0,1-.018.083c0,.011-.007.023-.011.034l-.014.034c-.005.012-.011.023-.017.034s-.016.027-.025.041l-.016.023a.577.577,0,0,1-.05.058h0L8.368,10.859a.536.536,0,1,1-.757-.76L9.383,8.335H4.837a.536.536,0,1,1,0-1.073H9.383L7.611,5.5a.536.536,0,1,1,.757-.76Z",
    transform: "translate(715.241 1410.201)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRightSideArrow);
export default __webpack_public_path__ + "static/media/greenRightSideArrow.4e1b10daf192bf6b6b8bc38ed0dc98df.svg";
export { ForwardRef as ReactComponent };